export * from "./react-native-jieba.web.ts";
